import { FaAward, FaHandshake, FaUsers } from "react-icons/fa";
import { motion } from "framer-motion";

const Beneficios = () => {
    const data = [
        {name:"Reconocimiento", text:"Genera un punto de conexión con tus colaboradores.", icon:FaAward },
        {name:"Versatilidad", text:"Otorgar bonos, apoyos o asistencias, nunca fue tan fácil.", icon:FaUsers },
        {name:"Aceptación", text:"Compras y consumos en cualquier establecimiento.", icon:FaHandshake },
    ];

    return (
        <div className="w-full h-fit md:h-screen flex flex-col">
            <div className="h-full w-full text-center flex justify-center items-center">
                <h1 className="text-6xl font-semibold">Sus Beneficios</h1>
            </div>
            <motion.div
                initial={{ opacity: 0, y: 150 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                className="h-full w-full grid grid-cols-1 md:grid-cols-3"
                viewport={{ once: true, amount: 0.3 }}
            >
                {data.map((card) => {
                    const Icon = card.icon;

                    return(
                    <div className="w-full h-full flex flex-col items-center justify-center gap-4 p-10 text-center">
                        <div className="w-1/2 aspect-square rounded-full bg-yellow-100 flex justify-center items-center">
                            <Icon size={75} className="text-black/75" />
                        </div>
                        <h2 className="text-3xl font-semibold"> {card.name} </h2>
                        <p className="text-lg"> {card.text} </p>
                    </div>
                )})}
            </motion.div>
        </div>
    );
};

export default Beneficios;